import { ManageAccounts } from '@mui/icons-material';
import {
    IconButton,
    Paper,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Tooltip,
} from '@mui/material';
import ToolCardSimple from '../../../Common/components/ToolCardSimple/ToolCardSimple';
import { CapabilityTool } from '../../../Common/models/tools';
import { ToolInfoDto } from '../../UserSearch/api/models/ToolInfoDto';

interface AdminToolGridProps {
    tools: ToolInfoDto[];
    onManageAccess: (tool: ToolInfoDto) => void;
}

const AdminToolGrid = ({ tools, onManageAccess }: AdminToolGridProps): JSX.Element => {
    return (
        <TableContainer
            component={Paper}
            data-testid='admin-tools-grid'
            sx={{
                display: 'flex',
                justifyContent: 'center',
            }}
        >
            <Table>
                <TableHead>
                    <TableRow>
                        <TableCell sx={{ width: '20%' }}>
                            <b>Name</b>
                        </TableCell>
                        <TableCell sx={{ width: '70%' }}>
                            <b>Description</b>
                        </TableCell>
                        <TableCell sx={{ width: '10%' }}>
                            <b>Actions</b>
                        </TableCell>
                    </TableRow>
                </TableHead>
                <TableBody>
                    {tools.map((tool) => (
                        <TableRow key={tool.capabilityToolKey}>
                            <TableCell>
                                <ToolCardSimple
                                    toolKey={tool.capabilityToolKey as CapabilityTool}
                                    toolName={tool.toolName}
                                    toolDisplayName={tool.toolDisplayName || tool.toolName}
                                />
                            </TableCell>
                            <TableCell>{tool.description}</TableCell>
                            <TableCell>
                                <Tooltip title='Manage Access'>
                                    <IconButton
                                        onClick={() => onManageAccess(tool)}
                                        size='small'
                                        color='secondary'
                                    >
                                        <ManageAccounts />
                                    </IconButton>
                                </Tooltip>
                            </TableCell>
                        </TableRow>
                    ))}
                </TableBody>
            </Table>
        </TableContainer>
    );
};

export default AdminToolGrid;
